import CoreAlertBanner from './CoreAlertBanner';

export { type CoreAlertBannerProps } from './CoreAlertBanner';
export default CoreAlertBanner;
